import React from 'react';
import { UNIVERSAL_ROOT_DOCS } from '../../config/LegalTaxonomy';

const FOCUS_INPUT_VALUE = '__focus_input__';

// Correção 16/09/2026 (4ª rodada — o titular corrigiu a interpretação
// anterior): não são dois controles empilhados e sempre visíveis — é UM
// campo só (sempre disponível, pra digitar OU receber o valor escolhido) e,
// à direita dele, um gatilho de menu pequeno e discreto (só uma seta, sem
// texto competindo com o campo) que fica fechado por padrão. As opções da
// lista só aparecem quando esse gatilho é aberto — dentro dele tem tanto os
// nomes da taxonomia (escolher um preenche o campo automaticamente) quanto
// um item "Digitar o nome" (não preenche nada, só joga o cursor pro campo).
// O `<select>` nativo já faz isso de graça (fechado = só a seta; aberto =
// lista) — o pulo do gato é nunca deixar esse `<select>` "lembrar" a última
// opção escolhida no que é mostrado fechado: o `value` dele fica sempre
// preso em `''`, então depois de qualquer escolha ele volta sozinho a
// mostrar só a seta, nunca o texto escolhido (isso é o que respondia pela
// reclamação de "amostra fica travada em Personalizado" das versões
// anteriores).
function SlotNameEditor({ nameValue, isMirrorMode, onChangeName, onBlurName, placeholder, ramoContext }) {
  const inputRef = React.useRef(null);

  if (isMirrorMode) {
    return (
      <span className="flex-1 min-w-0 text-sm font-semibold text-[#20243B] truncate px-0.5 uppercase">
        {nameValue || placeholder || '—'}
      </span>
    );
  }

  return (
    <div className="flex-1 min-w-0 flex items-center gap-1">
      <input
        ref={inputRef}
        value={nameValue}
        onChange={(e) => onChangeName(e.target.value)}
        onBlur={() => onBlurName(nameValue)}
        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); e.currentTarget.blur(); } }}
        placeholder={placeholder || 'Nome do documento...'}
        className="flex-1 min-w-0 text-sm font-semibold text-[#20243B] bg-transparent border-b border-[#C5A059]/50 focus:border-[#C5A059] focus:outline-none px-0.5 placeholder:text-slate-400 uppercase"
      />
      <select
        value=""
        onChange={(e) => {
          const val = e.target.value;
          if (!val) return;
          if (val === FOCUS_INPUT_VALUE) {
            inputRef.current?.focus();
            return;
          }
          onChangeName(val);
          onBlurName(val);
        }}
        title="Abrir menu: escolher nome da lista ou digitar"
        aria-label="Abrir menu de nome do documento"
        className="shrink-0 w-4 text-[11px] text-slate-400 bg-transparent border-none focus:outline-none cursor-pointer"
      >
        {/* Correção 16/09/2026 — reclamação do titular: a fonte das opções
            ABERTAS do menu vinha cinza-claro quase ilegível. Causa: o
            `<select>` fechado usa `text-slate-400` de propósito (gatilho
            discreto, "▾" sozinho) — mas sem cor própria em cada `<option>`,
            o texto das opções ABERTAS herdava esse mesmo cinza claro. Cor
            escura só no placeholder fechado; toda opção real (clicável) com
            `#20243B` (mesma cor de texto usada no resto do Portal),
            contraste alto contra o fundo branco do menu aberto. */}
        <option value="">▾</option>
        <option value={FOCUS_INPUT_VALUE} style={{ color: '#20243B' }}>⌨️ Digitar o nome...</option>
        <optgroup label="Documentos Universais (CNJ)">
          {UNIVERSAL_ROOT_DOCS.map((d) => (
            <option key={d.id} value={d.label} style={{ color: '#20243B' }}>{d.label}</option>
          ))}
        </optgroup>
        {ramoContext && (
          <optgroup label={`Sugestões — ${ramoContext.label}`}>
            {ramoContext.options.map((opt) => (
              <option key={opt} value={opt} style={{ color: '#20243B' }}>{opt}</option>
            ))}
          </optgroup>
        )}
      </select>
    </div>
  );
}

export default SlotNameEditor;
